module.exports = __webpack_public_path__ + "static/img/get_un_bunnyposy.6cdccdce.png";